export default __webpack_public_path__ + "spacelift.png";